const getters = {
  collapse: state => state.routes.collapse,
  routes: state => state.routes.routes,
  registerInfo: state => state.user.registerInfo,
  step: state => state.auth.step,
  regId: state => state.auth.regId,
}
export default getters
